/* Inline header search; uses the existing Shopify result renderer and price display. */
var soneeSearchSuggestions = window.soneeSearchSuggestions || (window.soneeSearchSuggestions = {
  read() {
    try {
      const terms = JSON.parse(localStorage.getItem('sonee-recent-searches') || '[]');
      return Array.isArray(terms) ? terms.filter(term => typeof term === 'string' && term.trim()).slice(0, 5) : [];
    } catch (_) { return []; }
  },
  save(value) {
    const term = value.trim().replace(/\s+/g, ' ').slice(0, 80);
    if (!term) return;
    const recent = this.read().filter(item => item.toLocaleLowerCase() !== term.toLocaleLowerCase());
    try { localStorage.setItem('sonee-recent-searches', JSON.stringify([term, ...recent].slice(0, 5))); } catch (_) { /* Storage may be disabled. */ }
  },
  recentLinks(searchUrl, limit = 5) {
    return this.read().slice(0, limit).map(term => {
      const link = document.createElement('a');
      const url = new URL(searchUrl, location.href);
      url.searchParams.set('q', term);
      url.searchParams.set('options[prefix]', 'last');
      link.href = url.href;
      link.textContent = term;
      return link;
    });
  },
  groups(searchUrl) {
    const recent = this.recentLinks(searchUrl);
    return recent.length ? [{ label: 'Recent searches', links: recent }] : [];
  }
});

if (!customElements.get('sonee-header-search')) {
  customElements.define('sonee-header-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[role="dialog"]');
      this.closeButton = this.querySelector('.sonee-inline-search__close');
      this.status = this.querySelector('[role="status"]');
      this.rememberCurrentSearch();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.mobile = window.matchMedia('(max-width: 768px)');
      this.header = this.closest('#SiteHeader');
      this.scrollAnchor = Math.max(0, window.scrollY);
      const measureHeader = () => {
        const wrapper = this.header.closest('#StickyHeaderWrap');
        if (!wrapper) return;
        this.pinAt = wrapper.getBoundingClientRect().top + window.scrollY;
        this.header.style.setProperty('--mobile-logo-height', `${this.offsetTop - 6}px`);
        this.header.style.setProperty('--mobile-header-height', `${this.header.offsetHeight}px`);
        wrapper.style.setProperty('--mobile-header-height', `${this.header.offsetHeight}px`);
      };
      const updateScroll = () => {
        const y = Math.max(0, window.scrollY);
        const delta = y - this.scrollAnchor;
        if (this.pinAt === undefined) measureHeader();
        this.header.classList.toggle('sonee-mobile-pinned', this.mobile.matches && y >= (this.pinAt || 0));
        if (!this.mobile.matches || y <= (this.pinAt || 0)) {
          this.classList.remove('is-scroll-hidden');
          this.inert = false;
          this.scrollAnchor = y;
          return;
        }
        if (Math.abs(delta) < 4) return;
        const hide = delta > 0;
        if (hide && !this.classList.contains('is-scroll-hidden')) this.scrollWasOpen = this.classList.contains('is-open');
        this.classList.toggle('is-scroll-hidden', hide);
        this.inert = hide;
        if (!hide && this.scrollWasOpen) { this.show(); this.scrollWasOpen = false; }
        this.scrollAnchor = y;
      };
      window.addEventListener('scroll', updateScroll, { ...options, passive: true });
      window.addEventListener('resize', () => {
        this.classList.remove('is-scroll-hidden');
        this.inert = false;
        this.scrollAnchor = Math.max(0, window.scrollY);
        measureHeader();
        updateScroll();
      }, options);
      window.addEventListener('load', () => { measureHeader(); updateScroll(); }, options);

      this.closeButton.addEventListener('click', () => { this.input.value = ''; this.input.focus(); this.close(); }, options);
      this.querySelector('form').addEventListener('submit', () => soneeSearchSuggestions.save(this.input.value), options);
      this.input.addEventListener('input', () => {
        this.close();
        if (!this.input.value.trim()) this.showDefaults();
        if (this.input.value.trim() && this.dataset.enabled !== 'false') {
          this.timer = setTimeout(() => this.search(), 250);
        }
      }, options);
      this.input.addEventListener('focus', () => {
        this.classList.remove('is-scroll-hidden');
        if (!this.input.value.trim()) this.showDefaults();
        if (this.input.value.trim() && this.dataset.enabled !== 'false') this.search();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (!this.classList.contains('is-scroll-hidden') && !this.contains(document.activeElement)) this.close(); }, 0);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.input.focus();
          this.close();
        }
        if (!this.results.hidden && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
          const links = [...this.results.querySelectorAll('a')].filter(link => link.getClientRects().length);
          if (!links.length) return;
          event.preventDefault();
          const current = links.indexOf(document.activeElement);
          const next = event.key === 'ArrowDown' ? current + 1 : current < 0 ? links.length - 1 : current - 1;
          (links[next] || this.input).focus();
        }
      }, options);
    }
    disconnectedCallback() { this.close(); this.events.abort(); }
    rememberCurrentSearch() {
      const searchPath = new URL(this.dataset.searchUrl, location.href).pathname.replace(/\/$/, '');
      if (location.pathname.replace(/\/$/, '') === searchPath) {
        soneeSearchSuggestions.save(new URLSearchParams(location.search).get('q') || '');
      }
    }
    showDefaults() {
      const content = document.createDocumentFragment();
      soneeSearchSuggestions.groups(this.dataset.searchUrl).forEach(group => {
        const section = document.createElement('section');
        section.className = 'sonee-inline-search__suggestion-group';
        const heading = document.createElement('h2');
        heading.textContent = group.label;
        const list = document.createElement('ul');
        list.className = 'sonee-inline-search__suggestions';
        group.links.forEach(link => {
          const item = document.createElement('li');
          item.append(link);
          list.append(item);
        });
        section.append(heading, list);
        content.append(section);
      });
      if (!content.childNodes.length) { this.close(); return; }
      this.results.replaceChildren(content);
      this.show();
    }
    show() {
      this.results.hidden = false;
      this.closeButton.hidden = false;
      this.classList.add('is-open');
      this.input.setAttribute('aria-expanded', 'true');
    }
    close() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.results.hidden = true;
      this.closeButton.hidden = true;
      this.classList.remove('is-open');
      this.input.setAttribute('aria-expanded', 'false');
      this.status.textContent = '';
    }
    async search() {
      this.request?.abort();
      const request = this.request = new AbortController();
      const query = this.input.value.trim();
      if (!query) return;
      try {
        const params = new URLSearchParams({ q: query, 'resources[limit]': '3', 'resources[limit_scope]': 'each', section_id: 'search-results' });
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (request.signal.aborted || this.input.value.trim() !== query) return;
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-search-results');
        if (!section) throw new Error('Missing search results');
        // Scope the native renderer's IDs to avoid collisions with the search page.
        section.querySelectorAll('[id]').forEach(el => { el.id = `${this.results.id}-${el.id}`; });
        section.querySelectorAll('[aria-labelledby]').forEach(el => el.removeAttribute('aria-labelledby'));
        section.querySelectorAll('[role="listbox"], [role="option"]').forEach(el => el.removeAttribute('role'));
        this.results.innerHTML = section.innerHTML;
        this.show();
        window.AOS?.refreshHard();
        this.status.textContent = 'Search suggestions updated.';
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.close();
          this.status.textContent = 'Suggestions unavailable. Press Enter to search.';
        }
      }
    }
  });
}

function updateSearchPageSuggestions(root = document) {
  root.querySelectorAll('[data-sonee-search-suggestions]').forEach(container => {
    if (container.dataset.soneeSuggestionsReady) return;
    container.dataset.soneeSuggestionsReady = 'true';
    const label = container.querySelector('span');
    const search = container.closest('.sonee-search__intro').querySelector('predictive-search');
    search.classList.add('has-dynamic-suggestions');
    const input = search.querySelector('input[type="search"]');
    const results = search.querySelector('.search__results');
    const positionResults = () => search.style.setProperty('--sonee-search-suggestion-offset', `${container.offsetHeight + 26}px`);
    const showDefaults = () => {
      const recent = soneeSearchSuggestions.recentLinks(container.dataset.searchUrl);
      container.hidden = !recent.length;
      label.textContent = 'Recent searches';
      container.replaceChildren(label, ...recent);
      positionResults();
    };
    const showQuery = () => {
      const query = input.value.trim();
      if (!query) { search.close(); showDefaults(); return; }
      container.hidden = false;
      const suggestions = [...results.querySelectorAll('.results--queries a')].filter(link => {
        const source = new URL(link.href).searchParams.get('_psq');
        return source && source.toLocaleLowerCase() === query.toLocaleLowerCase();
      }).slice(0, 5).map(link => {
        const suggestion = document.createElement('a');
        suggestion.href = link.href;
        suggestion.textContent = link.textContent.trim();
        return suggestion;
      });
      if (suggestions.length) {
        label.textContent = 'Suggested searches';
        container.replaceChildren(label, ...suggestions);
      } else {
        const link = document.createElement('a');
        const url = new URL(container.dataset.searchUrl, location.href);
        url.searchParams.set('q', query);
        url.searchParams.set('options[prefix]', 'last');
        link.href = url.href;
        link.textContent = `Search for “${query}”`;
        label.textContent = 'Search';
        container.replaceChildren(label, link);
      }
      positionResults();
    };
    showDefaults();
    input.addEventListener('input', showQuery);
    new MutationObserver(showQuery).observe(results, { childList: true });
  });
}
updateSearchPageSuggestions();
document.addEventListener('shopify:section:load', event => updateSearchPageSuggestions(event.target));
